import { render, staticRenderFns } from "./BikeItems.vue?vue&type=template&id=87c01e56"
import script from "./BikeItems.vue?vue&type=script&lang=js"
export * from "./BikeItems.vue?vue&type=script&lang=js"
import style0 from "./BikeItems.vue?vue&type=style&index=0&id=87c01e56&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports